import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class OtpSerializer extends BaseSerializer {
  deserialize(raw) {
    const resData = raw?.data || raw?.error || raw;
    const isSuccess = raw?.success && (resData?.statusCode === 200 || resData?.data?.otp || resData?.otp);
    const otpPayload = resData?.data || resData;

    if (!isSuccess || (!otpPayload?.otp && !otpPayload?.token)) {
      return {
        statusCode: resData?.statusCode || raw?.status || 500,
        success: false,
        message: resData?.message || resData?.error?.message || 'Impossible d\'envoyer le code de vérification. Veuillez réessayer.',
        data: null
      };
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Code OTP envoyé avec succès',
      data: {
        otp: otpPayload.otp,
        token: otpPayload.token,
        exp: otpPayload.exp
      }
    };
  }

  serialize(data) {
    if (!data) return null;

    const channel = data.channel || 'email';
    const payload = {
      channel,
      number: true,
      service: 'rapidoo',
      name: data.name || 'Utilisateur'
    };

    if (channel === 'email' || (data.email && data.email.includes('@'))) {
      payload.email = data.email;
      payload.subject = 'Code de vérification Rapidoo';
      payload.senderName = 'Rapidoo';
    } else {
      let phoneNumber = (data.phoneNumber || '').replace(/\D/g, '');
      const prefix = data.prefix ? `${data.prefix}`.replace(/\D/g, '') : '';
      if (prefix === '229' && phoneNumber.startsWith('01')) {
        phoneNumber = phoneNumber.slice(2);
      }
      payload.phoneNumbers = prefix ? `${prefix}${phoneNumber}` : phoneNumber;
      payload.whatsappPhoneNumber = phoneNumber;
      if (prefix) payload.prefix = prefix;
    }

    return payload;
  }
}

export const otpSerializer = new OtpSerializer();
